module.exports = __webpack_public_path__ + "static/media/clients-05.49bf229c.svg";